import { createFileRoute } from "@tanstack/react-router";

import { myFeatureVotesQueryOptions } from "~/lib/functions/feature-votes";
import { visibleFeaturesQueryOptions } from "~/lib/functions/features";
import { myCoachLeadStatsQueryOptions } from "~/lib/queries/coachLeadsQuery";
import { myCoachWheelQueryOptions } from "~/lib/queries/coachWheelQuery";

import { LeadMagnetsPage } from "../-components/lead-magnets-page";

export const Route = createFileRoute(
  "/_user/my-coaching/business/lead-magnets/",
)({
  staticData: { title: "Assessments" },
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(myCoachWheelQueryOptions()),
      // Secondary: prefetch swallows a failure and the block is left out.
      context.queryClient.prefetchQuery(myCoachLeadStatsQueryOptions()),
      // The template cards' features and her votes, so the cards load with the
      // page and one she voted for loads as "You want this".
      context.queryClient.prefetchQuery(visibleFeaturesQueryOptions),
      context.queryClient.prefetchQuery(myFeatureVotesQueryOptions),
    ]);
  },
  component: LeadMagnetsRoute,
});

function LeadMagnetsRoute(): React.JSX.Element {
  const userId = Route.useRouteContext({
    select: (context) => context.user.clerkUserId,
  });
  return <LeadMagnetsPage userId={userId} />;
}
